<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>
    <div style="display: flex;justify-content: space-between;">
      <div>{{editName}}</div>
      <div>
        <el-select v-model="manyCategory" size="small" style="width: 150px;" placeholder="请选择分组" v-if="handleSelectionFactor.length > 0" @change="manyCategoryChange">
          <el-option
            v-for="item in envCategoryList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
  </template>

  <template #body>
    <el-table
      :data="list"
      border
      stripe
      height="100%"
      style="width: 100%"
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="name" label="因子名称" />
      <el-table-column prop="categoryId" label="所属分组">
        <template slot-scope="{row}">
          <div style="display: flex;align-items: center;justify-content: left;">
            <el-select v-model="row.categoryId" size="small" style="width: 150px;">
              <el-option
                label="无分组"
                :value="''">
              </el-option>
              <el-option
                v-for="item in envCategoryList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否启用" align="center" width="100">
        <template slot-scope="{row}">
          <my-switch
            v-model="row.status"
            @click.native.stop
          />
        </template>
      </el-table-column>
      <!-- <el-table-column prop="icon" label="图标">
        <template slot-scope="{row}">
          <div class="icon-wapper">
            <el-select v-model="row.icon" class="icon-class" size="small">
              <div slot="prefix">
                <span :class="row.icon"></span>
              </div>
              <el-option
                v-for="item in iconOptions"
                :key="item.id"
                :value="item.icon"
              >
                <span :class="item.icon"></span>
              </el-option>
            </el-select>
            <div
              :class="row.icon === '' ? 'el-icon-circle-close' : 'el-icon-circle-check'"
              :style="`color: ${row.icon === '' ? '#F85778' : '#1FC96E'};margin-left: 5px;`"
            ></div>
          </div>
        </template>
      </el-table-column> -->
    </el-table>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'

export default {
  name: 'EnvConfigEditor',
  extends: BaseEditor,
  props: {
    envFactor: {
      require: true,
      type: Array
    }
  },
  data () {
    return {
      input: '',
      envCategoryList: [],
      model: {
        name: ''
      },
      list: [],
      handleSelectionFactor: [],
      manyCategory: ''
    }
  },
  computed: {
    editName () {
      return '动环因子分组'
    }
  },
  methods: {
    // 多选缺失原因
    handleSelectionChange (val) {
      this.handleSelectionFactor = JSON.parse(JSON.stringify(val))
    },
    manyCategoryChange () {
      let {handleSelectionFactor, list, manyCategory} = this
      let tableDataMap = list.reduce((map, el) => {
        map[el.name] = el

        return map
      }, {})

      handleSelectionFactor.forEach(el => {
        tableDataMap[el.name].categoryId = manyCategory
      })
      this.list = Object.values(tableDataMap)
      setTimeout(() => {
        this.manyCategory = ''
        this.handleSelectionFactor = []
      }, 10)
    },
    getEnvFactorCategory () {
      this.$api.EnvFactor.getEnvFactorCategory().then(data => {
        this.envCategoryList = data
        this.setList()
      }).catch(console.error)
    },
    open () {
      if (!this.envFactor.length) return

      this.$api.EnvFactor.getEnvFactorCategory().then(data => {
        this.envCategoryList = data
      }).catch(console.error).finally(() => {
        this.setList()
      })
    },
    setList () {
      let {envFactor} = this

      if (this.envCategoryList.length === 0) {
        this.$notify({
          title: '失败',
          message: '暂无分组请添加分组',
          type: 'error',
          position: 'bottom-right'
        })
        this.opened = false
      } else {
        this.opened = true
        let data = JSON.parse(JSON.stringify(envFactor))

        data.forEach(factor => {
          this.envCategoryList.forEach(envCategory => {
            if (factor.name.indexOf(envCategory.name) !== -1 && !factor.hasOwnProperty('categoryId')) {
              factor.categoryId = envCategory.id
            }
          })
        })

        this.list = data.map(el => {
          if (!el.categoryId) {
            return {
              ...el,
              categoryId: ''
            }
          }

          return el
        })
      }
    },
    onSaveBtnClick () {
      let {list} = this

      this.changeLoadStatus(false)

      this.$api.EnvFactor.updateEnvFactorCategory(list).then(data => {
        if (data) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success',
            position: 'bottom-right'
          })
          this.$emit('save')
          this.$store.dispatch('EnvFactor/request')
          this.opened = false
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-wapper {
  display: flex;
  align-items: center;
  justify-content: left;

  /deep/ .icon-class {
    width: 70px;
    height: 30px;
    border: 1px solid #DCDFE6;

    .el-input {
      .el-input__inner {
        display: none;
      }
      .el-input__suffix {
        width: 30px;
        height: 30px;
      }

      .el-input__prefix {
        width: 30px;
        height: 30px;

        > div > span {
          line-height: 30px;
          color: black;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/EnvConfigEditor.vue